<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>

      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Módulos</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Admin_modulos</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Administración de módulos
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>

              <b-form-group align="left">
                <label for="nombreBusq">Palabra clave</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="nombre" placeholder="Nombre del módulo, tratamiento"
                                v-model="filtro.palabraClave" @keydown.enter.native="obtenerModulos"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

            </b-col>

            <b-col></b-col>

            <b-col align="right">
              <b-button v-b-tooltip.hover title="Crear módulo" variant="outline-success"
                        @click="agregar()">Crear módulo
              </b-button>
            </b-col>

          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                    title="Detalle del plan"
                    size="sm"
                    @click="detalle(row.item)"
                    variant="outline-danger"
                ><em class="fa fa-eye"></em></b-button>
                <b-button
                    v-if="row.item.idModulo > 0"
                    title="Modificar plan"
                    size="sm"
                    @click="modificar(row.item)"
                    variant="outline-warning"
                ><em class="fa fa-pencil"></em></b-button>
                <b-button v-if="!row.item.registroActivo && row.item.idModulo > 0"
                          title="Activar menú"
                          variant="outline-danger"
                          size="sm"
                          @click="eliminar(row.item)"
                ><em class="fa fa-undo"></em></b-button>
                <b-button v-if="row.item.registroActivo && row.item.idModulo > 0"
                          title="Eliminar modulo"
                          variant="outline-danger"
                          size="sm"
                          @click="eliminar(row.item)"
                >  <b-icon icon="trash-fill"></b-icon></b-button>
              </b-button-group>

            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>


      </b-row>

    </b-container>


    <b-modal
        v-model="show"
        :title="tituloModal"
        size="lg"
        no-close-on-backdrop
    >
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group align="left">
                <label for="nombreMenu">Nombre
                  <validacion />
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input id="nombremodulo" name="nombremodulo" placeholder="Nombre del menú"
                                v-model="$v.modulo.nombre.$model"
                                :state="validateState('nombre')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group align="left">
                <label for="permiso">Tratamientos
                  <validacion />
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="card-checklist"></b-icon>
                  </b-input-group-prepend>
                  <v-select id="permiso" name="permiso" placeholder="Tratamientos"
                            label="nombre"
                            multiple
                            :options="tratamientos"
                            v-model="modulo.tratamientos"
                            style="width: 95%"
                  ></v-select>
                </b-input-group>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardar()">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </div>
    </b-modal>

    <b-modal
        v-model="showDetalle"
        :title="'Detalle del menú'"
        size="lg"
        no-close-on-backdrop
    >
      <b-container fluid>
        <b-row>
          <b-col>
            <div v-if="moduloDetalle !== null">
              <b-form-group align="left">
                <label for="nombreMenu">Nombre
                  <validacion />
                </label>
                <p>{{moduloDetalle.nombre}}</p>
              </b-form-group>
              <b-form-group align="left">
                <label for="permiso">Tratamientos
                  <p v-for="(item, index) in moduloDetalle.tratamientos" :key="item.nombre+index">{{item.nombre}}</p>
                </label>

              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-danger" @click="cerrarModal()">Cerrar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import Header from "../../../components/Header";

export default {
  name: "Modulos",
  components: {
    Header
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      datosTabla: [],
      fields: [
        {key: "idModulo", label: "ID", sortable: true},
        {key: "nombre", label: "Nombre", sortable: true},
        "Acciones",
      ],
      registrosPorPagina: 10,
      paginaActual: 0,
      show: false,
      showDetalle: false,
      tituloModal: '',
      modulo: {
        idMenu: null,
        nombre: null,
        tratamientos: []
      },
      moduloDetalle: null,
      tratamientos: [],
      loaderAcciones: false,
      loader: false,
      filtro: {
        id: null,
        palabraClave: null,
        registroActivo: null
      },
      moduloslista: []
    }
  },
  validations: {
    modulo: {
      nombre: {required}
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerModulos();
    this.obtenerTratamientos();
  },
  methods: {
    obtenerModulos() {
      this.loader = true
      this.datosTabla = [];
      this.$http.post(this.$api + 'modulo/obtener', this.filtro).then(respuesta => {
            if (respuesta.data.data){
              this.datosTabla = respuesta.data.data
            }
          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },
    obtenerTratamientos() {
      this.$http.get(this.$api + 'planConvenio/obtener/tratamientos/categoria').then(
          respuesta => {
            if (respuesta.data.data) {
              this.tratamientos = respuesta.data.data;
            }

          }
      )
    },
    detalle(item) {
      this.moduloDetalle = item;

      this.showDetalle = true;
    },
    agregar() {
      this.modulo = {
        idModulo: null,
        nombre: null,
        tratamientos: [],
      };
      this.tituloModal = 'Agregar módulo';
      this.show = true;
    },
    guardar() {
      this.$v.modulo.$touch();
      if (this.$v.modulo.$anyError) {
        return;
      }
      if (!this.$v.modulo.$invalid) {
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'modulo/guardar', this.modulo).then(respuesta => {
              if (respuesta.data.data) {
                this.obtenerModulos();
                this.show = false;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "El módulo se guardó correctamente",
                });
              }
            }
        ).finally(() => {
              this.loaderAcciones = false;
            }
        )
      }
    },
    modificar(item) {
      this.modulo = item;
      this.tituloModal = 'Modificar módulo';
      this.show = true;
    },

    eliminar(item) {
      const mensaje =  item.registroActivo ? '¿Está seguro de desactivar el módulo?' : '¿Está seguro de activar el módulo?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros = {
            idModulo: item.idModulo,
          }
          this.$http.post(this.$api + 'modulo/eliminar', parametros).then(respuesta => {
                if (respuesta.data.data) {
                  item.registroActivo = !item.registroActivo;
                  this.obtenerModulos();
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "El módulo se actualizó correctamente",
                  });
                }
              }
          )
        }
      })
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.modulo[name];
      return $dirty ? !$error : null;
    },
    cerrarModal() {
      this.showDetalle = false;
      this.show = false;
    }
  }
}
</script>

<style scoped>

</style>
